import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import rollupFilterDropdown from 'scoreboard/datasets/filters/rollup-filter-dropdown'
import selects from 'scoreboard/components/selects'

/**
 * Renders a rollup select for a principal row in datasets-principal-panel.js
 */
const PermissionsRollupSelect = Backbone.View.extend({

	events: {
		'change select': 'onChange'
	},

	/**
	 * @param options.principal
	 * @param {Element|JQuery} options.modelRow
	 * @param {String} options.selectedValue
	 */
	initialize(options = {}) {
		this.options = options
		this.principal = options.principal
		this.modelRow = options.modelRow
		this.selectedValue = options.selectedValue || this.principal.rollupPermission
	},

	render: function () {
		this.$el.append('<select class="permissions-rollup-select">')
		rollupFilterDropdown(this.$('select'), this.selectedValue, {
			isPermissionFilter: true,
			labelFn: opt => {
				let label = opt.key
				if (this.principal.rollupTreeGroupLabel) {
					label = i18n.get(`${opt.key}.withArg`,
						i18n.get(`datasets.filters.pretty.text.eachItemFor`,
						this.principal.rollupTreeGroupLabel))
				}
				return label
			}
		})
		return this
	},

	onChange: function (e) {
		this.trigger('change', {
			rollupPermission: e.target.value,
			principal: this.principal,
			modelRow: this.modelRow
		})
	},

	/**
	 * Set the option to the given value
	 * @param {String} value
	 */
	val: function(value) {
		selects.val(this.$('select'), value)
	}
})

export default PermissionsRollupSelect

PermissionsRollupSelect.__filename__ = 'datasets/edit/permissions-rollup-select.js'
